import styled from 'styled-components/macro';
import { variables } from 'theme/variables';
const { custom_light_grey, custom_border_grey, spacing_md } = variables;

export const PaginationWrapper = styled('div')`
  padding-top: ${spacing_md};
  border-top: ${(props) =>
    props.borderTop ? `1px solid ${custom_light_grey}` : 'none'};
  ${(props) =>
    props.public
      ? `
    height: auto;
    padding: 10px;
    background: #fff;
    border: 1px solid ${custom_border_grey};
    border-top: none;
    border-bottom-right-radius: 8px;
    border-bottom-left-radius: 8px;
    * {
      color: #76899e !important;
      font-size: 14px !important;
    }
    div[type="button"], div[type="button"] * {
      font-size: 12px !important;
    }
    .icon-chevron-left, .icon-chevron-right {
       font-size: 10px !important; 
    } 
    @media (max-width: 600px) {
      .description, .limit-col {
        display: none;
      }
    }
  `
      : ''}
`;
